export const iconFontAwesomeTimeCalendarDays = (
	<i className="fa-solid fa-calendar-days"></i>
);
